/*
 * Project: BookingEngine
 * Module: components/booking/confirmation/ThanksWaitScreen.js
 * vim:ft=javascript.jsx:
 */
import React from 'react';
import PropTypes from 'prop-types';

import DsErrorScreen from '../../ds/atoms/error/errorScreen';
import Btn from '../../ds/atoms/btn';
import '../../../static/images/loading5.gif';
import '../../../static/less/layout/loading_screen.less';

//to be removed from this screen
const renderBookLoading = (props, context) => (
  <div className="LoadingScreen row">
    <div className="col-md-12 col-sm-12 col-xs-12 LoadingProgress">
      <img src="/img/loading5.gif"/>
      <p>{context.t('Retrieving your booking...')}</p>
    </div>
  </div>
);

const renderBookLoadError = ({ onClickReload }, context) => (
  <DsErrorScreen>
      <p>{context.t('We are sorry, but your booking could not be retrieved. Please, contact the hotel for assistance.')}</p>
      <Btn icon="refresh" variant="primary" onClick={onClickReload}>
        {context.t('Try again')}
      </Btn>
  </DsErrorScreen>
);

const renderPaymentPending = ({ onClickPay, onClickCancel, callCenterPhones }, context) => (
  <DsErrorScreen title={context.t('We are sorry, your booking has pending payments')}>
    <p>{context.t('This means that the payment for your booking did not complete correctly.')}</p>
    <p>{context.t('Please, contact our Call Center for assistance.')}</p>
    {callCenterPhones && callCenterPhones.split('\n').map((line, i) => <p key={i}>{line}</p>)}
    <div className="-mx-2">
      <Btn variant="primary" className="mx-2" disabled={onClickPay}>
        {context.t('Go to payment page')}
      </Btn>
      <Btn variant="cancel" className="mx-2" onClick={onClickCancel}>
        {context.t('Cancel your booking')}
      </Btn>
    </div>
  </DsErrorScreen>

);

const BookingLoadingScreen = (props, context) => {
  switch (props.mode) {
    case 'loading':
      return renderBookLoading(props, context);
    case 'pending':
      return renderPaymentPending(props, context);
    case 'error':
    default:
      return renderBookLoadError(props, context);
  }
};

BookingLoadingScreen.propTypes = {
  onClickPay: PropTypes.func,
  onClickCancel: PropTypes.func,
  onClickReload: PropTypes.func,
  mode: PropTypes.oneOf(['error', 'pending', 'loading']),
  callCenterPhones: PropTypes.string,
};

BookingLoadingScreen.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default BookingLoadingScreen;
